import { routerActions } from "connected-react-router";

import { IStoreState } from "@montana/store/store";
import { IRouterContainerState } from "@montana/containers/router/router";
import { generateContainer, IContainerProps } from "../base/generate-container";

const mapState = (state: IStoreState): IRouterContainerState => state.router || {};

export type IRouterContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof routerActions>;

export const [RouterContainer, connectWithRouter, useRouter] = generateContainer(mapState, routerActions);
